// src/components/PaymentAnnouncementBanner.tsx
import { useState, useEffect, useCallback, memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var STORAGE_KEY = "flote_ach_banner_dismissed";
var BANNER_VERSION = "1";
var PaymentAnnouncementBanner = memo(
  ({ className = "" }) => {
    const [isDismissed, setIsDismissed] = useState(true);
    useEffect(() => {
      try {
        const dismissed = localStorage.getItem(STORAGE_KEY);
        setIsDismissed(dismissed === BANNER_VERSION);
      } catch {
        setIsDismissed(false);
      }
    }, []);
    const handleDismiss = useCallback(() => {
      setIsDismissed(true);
      try {
        localStorage.setItem(STORAGE_KEY, BANNER_VERSION);
      } catch {
      }
    }, []);
    if (isDismissed) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        role: "alert",
        className: `relative bg-blue-50 border-b border-blue-200 px-4 py-2.5 ${className}`.trim(),
        children: /* @__PURE__ */ jsxs("div", { className: "max-w-7xl mx-auto flex items-center justify-between gap-3", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 min-w-0", children: [
            /* @__PURE__ */ jsx(
              "svg",
              {
                className: "h-4 w-4 text-blue-600 flex-shrink-0",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: 1.5,
                stroke: "currentColor",
                children: /* @__PURE__ */ jsx(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxs("p", { className: "text-sm text-blue-800", children: [
              /* @__PURE__ */ jsx("span", { className: "font-medium", children: "Payment Update:" }),
              " ",
              /* @__PURE__ */ jsx("span", { className: "hidden sm:inline", children: "We now accept ACH bank payments only \u2014 fast, free, and secure." }),
              /* @__PURE__ */ jsx("span", { className: "sm:hidden", children: "ACH payments only \u2014 fast & free." }),
              " ",
              /* @__PURE__ */ jsx(
                "a",
                {
                  href: "https://vimeo.com/1142787743?fl=ip&fe=ec",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "underline font-medium hover:text-blue-900",
                  children: "Learn more"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: handleDismiss,
              className: "flex-shrink-0 p-1 text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded transition-colors",
              "aria-label": "Dismiss announcement",
              children: /* @__PURE__ */ jsx(
                "svg",
                {
                  className: "h-4 w-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  strokeWidth: 2,
                  stroke: "currentColor",
                  children: /* @__PURE__ */ jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18 18 6M6 6l12 12" })
                }
              )
            }
          )
        ] })
      }
    );
  }
);
PaymentAnnouncementBanner.displayName = "PaymentAnnouncementBanner";

export {
  PaymentAnnouncementBanner
};
